import { render, staticRenderFns } from "./AideGestion.vue?vue&type=template&id=61163dab"
import script from "./AideGestion.vue?vue&type=script&lang=js"
export * from "./AideGestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports